import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './ShowMoreRow.scss';

interface Props {
  className?: string;
  onClick?: () => void;
}

const ShowMoreRow: FC<Props> = ({ className, onClick }) => {
  const { t } = useTranslation();
  return (
    <tr className={s['root']}>
      <td colSpan={1000}>
        <TextButton
          className={className}
          size="small"
          variant="main"
          onClick={onClick}
          postfix={<ArrowDown size={IconSize.SMALL} disableDefaultColors />}
        >
          {t('studio.reports.section.common.table.showMore')}{' '}
        </TextButton>
      </td>
    </tr>
  );
};
ShowMoreRow.displayName = 'ShowMoreRow';

export default ShowMoreRow;
